import { useState } from "react";
import emailjs from "emailjs-com";
import { apiBaseAssets } from "../config/api";
import swal from "sweetalert";
import lc from "../utils/language";
export const Contact = ({ data, isRtl }) => {
  const initialState = {
    name: "",
    email: "",
    message: "",
  };
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    emailjs
      .sendForm(
        "service_ome5iqx",
        "template_a6xe408",
        e.target,
        "user_yCL5qyKxk4cT8xgprgHsN"
      )
      .then(
        (result) => {
          if (isRtl) {
            swal(
              "تم استقبال الرسالة بنجاح",
              "سنقوم بالتواصل معك قريبا. شكرا على ارسالك لنا!",
              "success"
            );
          } else {
            swal(
              "We Received your Message",
              "We will be in touch soon, thanks for contacting us!",
              "success"
            );
          }

          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div style={{ background: 'linear-gradient(260.94deg, rgba(47, 128, 237, 0.24) 0%, rgba(127, 182, 255, 0.24) 100%)' }}>
      <div id="contact">
        <div className="container">
          <div className="col-md-12" style={{ textAlign: 'center' }}>
            <div className="row">
              <div className="section-title" style={{ background: 'none' }}>
                <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Merriweather" }}>
                  {data[lc("title", isRtl)]}
                </h2>
                <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
                  {data[lc("subTitle", isRtl)]}
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={isRtl ? "الاسم الكامل" : "Full Name"}
                        required
                        onChange={handleChange}
                        style={{
                          fontFamily: isRtl ? "amiriBold" : "Open Sans", borderRadius: '8px'
                        }}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={isRtl ? "البريد الالكتروني" : "Email"}
                        required
                        onChange={handleChange}
                        style={{
                          fontFamily: isRtl ? "amiriBold" : "Open Sans", borderRadius: '8px'
                        }}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="6"
                    placeholder={isRtl ? "الرسالة" : "Message"}
                    required
                    onChange={handleChange}
                    style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", borderRadius: '8px' }}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  style={{
                    fontFamily: isRtl ? "amiriBold" : "Open Sans", width: '100%',
                    background: 'linear-gradient(269.82deg, #2F80ED 0%, #7FB6FF 100%)',
                    border: 'none', borderRadius: '8px'
                  }}
                >
                  {isRtl ? "ارسل الرسالة" : "Send Message"}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-12 col-md-offset-1 contact-info" style={{ margin: 0 }} >
            <div className="contact-item" style={{ width: isRtl ? '100%' : '100%' }}>
              <h3 style={{
                fontFamily: isRtl ? "amiriBold" : "Merriweather", color: '#fff', width: '100%', textAlign: 'center',
                fontSize: '24px', fontWeight: 'bold'
              }}>
                {isRtl ? "معلومات الاتصال" : "Contact Info"}
              </h3>
              {/* <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}>
                <span
                  style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}
                >
                  <i className="fa fa-map-marker"></i>{" "}
                  {isRtl ? "العنوان" : "Address"}
                </span>
                {data.addressEN ? data[lc("address", isRtl)] : "loading"}
              </p> */}
            </div>
            <div className="divCon" style={{ display: 'flex', flexWrap: 'wrap'/*, justifyContent: 'space-between'*/ }}>
              <div>
                <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", textAlign: 'center' }}>
                  <span
                    style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}
                  >
                    <i className="fa fa-map-marker"></i>{" "}
                    {isRtl ? "العنوان" : "Address"}
                  </span><br /><br />
                  {data.addressEN ? data[lc("address", isRtl)] : "loading"}
                </p>
              </div>
              <div >
                <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", textAlign: 'center' }}>
                  <span style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
                    <i className="fa fa-envelope-o"></i>{" "}
                    {isRtl ? "البريد الالكتروني" : "Email"}
                  </span><br /><br />
                  {data.email ? data.email : "loading"}
                  <br />
                  {data.email1 ? data.email1 : "loading"}
                </p>
              </div>
              <div>
                <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", textAlign: 'center' }}>
                  <span style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
                    <i className="fa fa-mobile"></i> {isRtl ? "الجوال" : "Mobile"}
                  </span>{" "}<br /><br />
                  {data.mobile ? data.mobile : "loading"} <br />
                  {data.mobile1 ? data.mobile1 : "loading"}
                  <br />
                  {data.mobile2 ? data.mobile2 : "loading"}
                </p>
              </div>
            </div>
            {/* <div className="contact-item">
              <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}>
                <span>
                  <i className="fa fa-phone"></i> {isRtl ? "الهاتف" : "Phone"}
                </span>{" "}
                {data.phone ? data.phone : "loading"}
              </p>
            </div> */}
            {/* <div className="contact-item">
              <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}>
                <span>
                  <i className="fa fa-mobile"></i> {isRtl ? "الجوال" : "Mobile"}
                </span>{" "}
                {data.mobile ? data.mobile : "loading"} <br />
                {data.mobile1 ? data.mobile1 : "loading"}
                <br />
                {data.mobile2 ? data.mobile2 : "loading"}
              </p>
            </div> */}
            {/* <div className="contact-item">
              <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}>
                <span>
                  <i className="fa fa-envelope-o"></i>{" "}
                  {isRtl ? "البريد الالكتروني" : "Email"}
                </span>
                {data.email ? data.email : "loading"}
                <br />
                {data.email1 ? data.email1 : "loading"}
              </p>
            </div> */}
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  {data.contacts.length > 0
                    ? data.contacts.map((d) => (
                      <li key={d._id}>
                        <a href={d.link ? d.link : "/"}>
                          <img
                            src={apiBaseAssets + d.background}
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                            }}
                          />
                        </a>
                      </li>
                    ))
                    : "Loading...."}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" style={{ backgroundColor: "#000" }}>
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} {!isRtl ? 'All Rights Reserved To PROCAST.Powerde By' : "جميع الحقوق محفوظة لـ PROCAST. طور بواسطة"}{" "}
            <a href="https://www.perla-tech.com" rel="nofollow">
              <img src="img/WW5 1.png" style={{ width: '96px', height: '18.05px' }} />
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
